/* eslint-disable @typescript-eslint/no-shadow */
import React from 'react';
import TWInvoicePreview from '../../TWInvoicePreview'; // import { pluralize } from '../../../utils/helpers'

import IncludedAssetSummary from '../IncludedAssetSummary.container';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var OrderSummary = function OrderSummary(_ref) {
  var plan = _ref.plan,
      order = _ref.order,
      orderDetails = _ref.orderDetails;
  return /*#__PURE__*/_jsxs("div", {
    children: [orderDetails, plan && /*#__PURE__*/_jsxs("div", {
      className: "mt-0 rounded-lg border border-gray-300 px-4 py-6",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "mt-0",
        children: "Summary"
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-4",
        children: /*#__PURE__*/_jsxs("div", {
          className: "w-full text-base",
          children: [!!order.invoicePreview && /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx("div", {
              className: "mt-6",
              children: /*#__PURE__*/_jsx(TWInvoicePreview, {
                invoicePreview: order.invoicePreview,
                totalLineItemTitle: "Today's charge:"
              })
            })
          }), order.includedAssets && /*#__PURE__*/_jsx(IncludedAssetSummary, {
            includedAssets: order.includedAssets
          })]
        })
      })]
    })]
  });
};